import React from 'react';
import { useTranslation } from 'react-i18next';
import { ShortcutInput } from 'shared/components/ui/shortcut-input';
import { useCreateTaskShortcutQuery } from 'shared/hooks/queries/use-create-task-shortcut-query';
import { useSetCreateTaskShortcutMutation } from 'shared/hooks/queries/use-set-create-task-shortcut-mutation';

export const LoadingCreateTaskShortcut = () => null;

export const CreateTaskShortcut = () => {
  const { t } = useTranslation();
  const { data: selectedShortcut, refetch: refetchShortcut } =
    useCreateTaskShortcutQuery();
  const { mutateAsync: setCreateShortCut } = useSetCreateTaskShortcutMutation();

  const onChangeCreateShortcut = async (value: string | null) => {
    await setCreateShortCut(value);
    await refetchShortcut();
  };

  return (
    <ShortcutInput
      id="create-task-shortcut"
      value={selectedShortcut ?? null}
      onChange={onChangeCreateShortcut}
      label={t('forms.user-settings.sections.shortcuts.fields.shortcuts.label')}
      placeholder={t(
        'forms.user-settings.sections.shortcuts.fields.shortcuts.placeholder',
      )}
      helperText={t(
        'forms.user-settings.sections.shortcuts.fields.shortcuts.helper-text',
      )}
    />
  );
};
